import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import { PromptLibraryModal } from "../ui/common_components/PromptLibraryModal";
import { usePromptInputActions } from "../view_stores/usePromptInputStore";

interface PromptLibraryModalContextType {
  open: () => void;
  close: () => void;
}

const PromptLibraryModalContext = createContext<
  PromptLibraryModalContextType | undefined
>(undefined);

export function usePromptLibraryModal() {
  const ctx = useContext(PromptLibraryModalContext);
  if (!ctx)
    throw new Error(
      "usePromptLibraryModal must be used within a PromptLibraryModalProvider"
    );
  return ctx;
}

export function PromptLibraryModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const { setPrompt } = usePromptInputActions();

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleSelectPrompt = useCallback(
    (promptText: string) => {
      setPrompt(promptText);
    },
    [setPrompt]
  );

  return (
    <PromptLibraryModalContext.Provider value={{ open, close }}>
      {children}
      {isOpen && (
        <PromptLibraryModal
          onClose={close}
          onSelectPrompt={handleSelectPrompt}
        />
      )}
    </PromptLibraryModalContext.Provider>
  );
}
